import { Component, OnInit } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomTagsParticipantLinkViewModel } from '../../../models/custom-tags-participant-link';
import { Select2OptionData } from 'ng-select2';
import { TerminalGroupsByParticipantLinkViewModel } from '../../../models/terminal-groups-participant-link';
import { ParticipantViewModel } from '../../../models/participant-view-model';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { ParticipantService } from '../../../services/participant.service';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomTagService } from '../../../services/custom-tag.service';
import { UserDataStoreService } from '../../../services/user-data-store.service';
import { PermissionEnum } from '../../../services/guards/permissions';
import { takeUntil } from 'rxjs/operators';
import { TerminalGroupCustomParameter } from '../../../models/terminal-group-param-view-model';
import { ConfirmationDialogComponent } from '../../../partials/confirmation-dialog/confirmation-dialog.component';
import { CreateResult } from '../../../models/create-result';

@Component({
  selector: 'app-terminal-group-custom-parameter',
  templateUrl: './terminal-group-custom-parameter.component.html',
  styleUrls: ['./terminal-group-custom-parameter.component.scss']
})
export class TerminalGroupCustomParameterComponent implements OnInit {

  public customTagsByParticipant: CustomTagsParticipantLinkViewModel[] = [];
  public customTags: Select2OptionData[];
  public allsinkNodes: Select2OptionData[];
  public mapCustomTags: Select2OptionData[];
  public TerminalGroupsByParticipant: TerminalGroupsByParticipantLinkViewModel[] = [];
  public mapTerminalGroupTags: Select2OptionData[];
  public terminalGroups: Select2OptionData[];
  public participant: ParticipantViewModel;
  public participantId?: number;
  public terminalGroupCustomParameter: TerminalGroupCustomParameter;

  public groupName: string;
  public terminalConfigId: string;
  public selectedCustomTag: string;
  public editConfig: boolean

  public canAdd = false;
  public canEdit = false;
  public canView = false;
  public canDelete = false;
  public createResult: CreateResult;
  public warning: boolean;
  public warningMessage: string;
  public disabled: string;
  public itemExist: boolean;
  public raiseDanger: boolean;
  public danger: string;
  public mapTaParamFiles: Select2OptionData[];


  public select2options: any = {
    multiple: false,
    width: '100%'
  };

  private _destroyed$ = new Subject<any>();

  constructor(private _modal: NgbActiveModal,
    private _route: ActivatedRoute,
    private _authenticationService: AuthenticationService,
    private _participantService: ParticipantService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private _modalService: NgbModal,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _customTagService: CustomTagService) {

    this.canView = this._userDataStore.hasRequiredPermissions([PermissionEnum.ViewTerminalConfiguration], []);
    if (!this.canView) {
      this._toastService.warning("You do not have the required permissions to view this terminal config.", "Warning");
      this._router.navigate(['Default', 'Home']);
    }
    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditTerminalConfiguration], []);
    this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddTerminalConfiguration], []);

  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
  }

  public async ngOnInit(): Promise<void> {


    this.customTags = (await this._customTagService.GetCustomTags()).map((x) => {
      return { id: x.tag.toString(), text: x.tag }
    });

    this.mapTaParamFiles = (await this._customTagService.GetTaParamFiles()).map((x) => {
      return { id: x.id.toString(), text: x.id }
    });

    if (this.terminalGroupCustomParameter != null) {
      this.editConfig = true;

      this.participantId = this.terminalGroupCustomParameter.participantId;
      this.customTagsByParticipant = await this._customTagService.GetCustomTagsByParticipantIdTerminalConfigIdGroupName(this.participantId, Number(this.terminalGroupCustomParameter.terminalConfigId), this.terminalGroupCustomParameter.groupName);
      if (this.customTagsByParticipant.length == 0) {
        this.warning = true;
        this.warningMessage = "";
      }
      else {
        this.warning = false;
      }
      this.filterCustomTags();
    }
    else {
      this.editConfig = false;

    }
  }

  public close() {
    this._modal.close();
  }

  public filterCustomTags(): void {
    const filteredItems = this.customTags.filter((item) => {
      if (this.customTagsByParticipant != null) {
        const index = this.customTagsByParticipant.findIndex(x => x.customTag.toString() === item.text);
        if (index > -1) {
          return false;
        }
      }
      return true;
    });
    this.mapCustomTags = filteredItems;
  }

  public async UpdateCustomParam(customParam: string, custonValue: string, fileId: string ): Promise<void> {

    var customParam_ = {
      customTag: customParam,
      participantId: this.participantId,
      terminalConfigId: this.terminalGroupCustomParameter.terminalConfigId,
      value: custonValue,
      groupName: this.terminalGroupCustomParameter.groupName,
      fileId: fileId
    }

    this.createResult = await this._customTagService.UpdateCustomParameter(customParam_);


    if (this.createResult.success) {
      this._toastService.success(this.createResult.message, 'Success');
    } else {
      this._toastService.error(this.createResult.message, 'Error');
    }
  }


  public async addCustomTagsFields(): Promise<void> {

    //this.itemExist = false;

    let tag: string = this.selectedCustomTag;
    if (tag == null) {
      alert('Select a Custom Parameter');
    }
    else {


      /*var tpf = await this._customTagService.GetCustomParamByParticipantId();
      if (tpf != null && tpf.length > 0) {

        tpf.forEach(mkey => {

          if (mkey.customTag == tag) {
            this.itemExist = true;
            this.raiseDanger = true;
            this.danger = "Custom parameter already exist within Terminal group '" + mkey.groupName + "', consider deleting '" + mkey.groupName + "' group"
            //this._toastService.error("Custom parameter already exist within Terminal group '" + mkey.groupName + "'", "Error");
            return;
          }
        });
      }*/

      //if (this.itemExist == false) {

      this.raiseDanger = false;

      var customParam = {
        customTag: this.selectedCustomTag,
        participantId: this.participantId,
        terminalConfigId: this.terminalGroupCustomParameter.terminalConfigId,
        value: '0000000',
        groupName: this.terminalGroupCustomParameter.groupName,
        fileId: ''
      }

      this.createResult = await this._customTagService.AddCustomParameter(customParam);


      if (this.createResult.success) {

        this.customTagsByParticipant.push(customParam);
        this._toastService.success(this.createResult.message, 'Success');
      } else {
        this._toastService.error(this.createResult.message, 'Error');
      }

      // }
      this.filterCustomTags();

    }
  }

  public async ClearCustomParameters(): Promise<void> {

    this.customTagsByParticipant.splice(0);
  }

  public async determineCustomTagsDeleteDialog(customTag: string) {
    this._ngxUiLoaderService.start();
    var terminals = await this._customTagService.GetTerminalsCountByCustomTags(customTag, this.participantId);
    this._ngxUiLoaderService.stop();
    if (!!terminals && terminals.length === 0) {
      await this.openDeleteCustomTagsConfirmationDialog(customTag);
    } else {
      await this.openCustomTagsUsedDeleteFailureConfirmationDialog(terminals.length, customTag);
    }
  }

  public async openDeleteCustomTagsConfirmationDialog(customTag: string) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Yes';
    dialogRef.componentInstance.cancelButtonText = 'No'
    dialogRef.componentInstance.title = 'Custom Tag Removal'
    dialogRef.componentInstance.message = 'Are you sure you want to delete the selected custom tag?'

    const result = await dialogRef.result;
    if (result) {
      await this.deleteMappedField(customTag);
    }
  }

  public async openCustomTagsUsedDeleteFailureConfirmationDialog(terminalCount: number, customTag: string) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Yes';
    dialogRef.componentInstance.cancelButtonText = 'No'
    dialogRef.componentInstance.title = 'Custom Tag Removal'
    dialogRef.componentInstance.message = `The Custom tag is currently in use by ${terminalCount} terminal(s), Are you sure you want to delete the selected custom tag?`

    const result = await dialogRef.result;
    if (result) {
      await this.deleteMappedField(customTag);
    }
  }

  public async deleteMappedField(customTag: string): Promise<void> {


    var customParam = {
      customTag: customTag,
      participantId: this.participantId,
      terminalConfigId: this.terminalGroupCustomParameter.terminalConfigId,
      value: '0000000',
      groupName: this.terminalGroupCustomParameter.groupName,
      fileId: ''
    }

    this.createResult = await this._customTagService.DeleteCustomParameter(customParam);


    if (this.createResult.success) {

      const index = this.customTagsByParticipant.findIndex(x => x.customTag == customTag && x.groupName == this.terminalGroupCustomParameter.groupName);

      if (index > -1) {
        this.customTagsByParticipant.splice(index, 1);
      }

      this._toastService.success(this.createResult.message, 'Success');
    } else {
      this._toastService.error(this.createResult.message, 'Error');
    }


    this.filterCustomTags();
  }

  public async saveCustomTag(): Promise<void> {

    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {

      this.createResult = await this._customTagService.DeleteCustomTagsByParticipantIdAndTerminalConfigGroupName(this.participantId, Number(this.terminalGroupCustomParameter.terminalConfigId), this.terminalGroupCustomParameter.groupName);

      if (this.createResult.success) {
        this.createResult = await this._customTagService.UpdateCustomTags(this.customTagsByParticipant);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, 'Success');
        } else {
          this._toastService.error(this.createResult.message, 'Error');
        }
      }
    }
  }
}
